import axios from 'axios';

import { IContact } from '../../entities/contact.entity';

export default class ContactApi {
  public static postContact = (contact: IContact) => {
    return axios.post('/api/contact', contact);
  };
}
